import * as msal from "@azure/msal-browser";

const hostname = window.location.hostname;
const isLocalhost = hostname.includes("localhost");

const cli = process.env.REACT_APP_CLIENT_ID;
const auth = process.env.REACT_APP_AUTHORITY;
const rUri = isLocalhost ? "http://localhost:3000/" : process.env.REACT_APP_REDIRECT_URI;
const siteUri = isLocalhost ? "http://localhost:3000/" : process.env.REACT_APP_SITE_URL;
const known = [process.env.REACT_APP_KNOWN_AUTHORITIES];

const msalConfig = {
  auth: {
    clientId: cli,
    authority: auth,
    redirectUri: rUri,
    knownAuthorities: known,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const loginRequest = {
  scopes: [process.env.REACT_APP_SCOPES],
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export const baseurl = process.env.REACT_APP_BASE_URL;
export const scopes = [process.env.REACT_APP_SCOPES];
export const siteurl = siteUri;

export { msalInstance, loginRequest };
